import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <h1 className="text-6xl font-black text-indigo-600 mb-4">404</h1>
      <h2 className="text-2xl font-bold mb-2">Oops! Page Missing</h2>
      <p className="text-gray-400 mb-8 max-w-xs">
        The reward you're looking for might have expired or moved to a new section.
      </p>
      <Link 
        to="/" 
        className="bg-white text-black font-bold py-3 px-8 rounded-xl hover:bg-gray-200 transition-colors"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
